import React, { useEffect, useState } from 'react'
import { ROUTE } from '../../route/Route'
import BreadCrumb from '../breadcrumb/BreadCrumb'
import SeoAdd from '../Seo/SeoAdd'
import { useTranslation } from 'react-i18next'

function Accreditations() {
  const { t } = useTranslation()
  useEffect(() => {
    window?.scrollTo(0, 0)
    return () => {}
  }, [])
  return (
    <>
      <SeoAdd slug={ROUTE.ACCREDATITION} />
      <BreadCrumb page={t('arrd')} data={{ slug: '', path: '#' }} />
      <section className="categories about-section pt-3">
        <div className="container" id="section2">
          <div className="row">
            <div className="col-md-12">
              <div className="overview-wrap text-center">
                <img src={t('accreditation.banner')} className="scale" alt="" />
                <div className="headingmains text-center pb-2">
                  <h1 className="right aos-init pb-2 mt-2 mt-lg-3">
                    {t('arrd')}
                  </h1>
                </div>
                <p className="text-center dull_heading pb-3">
                  {t('pillars_endeavour_text')}
                </p>
              </div>
            </div>
          </div>
          <section className="sub-section">
            <div className="row">
              <div className="col-md-4 justify-content-center text-center nbl-img-w">
                <img
                  src={t('accreditation.nabl_logo')}
                  className="scale"
                  alt=""
                />
              </div>
              <div className="col-md-8">
                <h4 className="text-left mb-0 py-3">{t('nabl')}</h4>
                <p
                  className="w-100 text-left py-3 f-16"
                  dangerouslySetInnerHTML={{
                    __html: t('accreditation_nabl_text'),
                  }}
                ></p>
              </div>
              <div className="container">
              <h4 className="text-center mb-0 py-3">Our Accreditations</h4>
                <div className="row">
                  <div className="col-sm-12 col-md-6 col-lg-4 my-4 pt-3 mpmobile">
                    <div className="h-well sbg1">
                      <div className="infobox_wrapper">
                        <div className="infobox_icon_container">
                          <img
                            src={t('images.quick_link.link4')}
                            className="scale"
                          />
                        </div>
                        <h4 className="infobox_title pl-4">{t('gurugram_lab')}</h4>
                        <div className="d-flex" style={{gap:'10px'}}>
                        <a
                          href="/assets/pdf/Certificate_MC-5076.pdf"
                          target="_blank"
                          className="mt-4 button--hexagon1 certi-icon"
                        >
                            <img src="./src/assets/img/certificate-icon.png" alt="" />
                          <span><img className="scale_download mr-2" src="/assets/img/certificate-icon.png" aria-hidden="true" />Certificate</span>
                        </a>
                        <a
                          href="/assets/pdf/Scope-90395-MC-5076.pdf"
                          target="_blank"
                          className="mt-4 button--hexagon1 certi-icon"
                        >
                             
                          <span><img className="scale_download mr-2" src="/assets/img/scope-icon.png" aria-hidden="true" />Scope</span>
                        </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </section>
    </>
  )
}

export default Accreditations
